import { SEVERITY_ORDER } from '../types/finding.js';
export function compareSeverity(a, b) {
    return SEVERITY_ORDER[a] - SEVERITY_ORDER[b];
}
export function getHighestSeverity(counts) {
    if (counts.critical > 0)
        return 'critical';
    if (counts.high > 0)
        return 'high';
    if (counts.medium > 0)
        return 'medium';
    if (counts.low > 0)
        return 'low';
    if (counts.info > 0)
        return 'info';
    return null;
}
export function getSeverityEmoji(severity) {
    const emojis = {
        critical: '🔴',
        high: '🟠',
        medium: '🟡',
        low: '🔵',
        info: '⚪',
    };
    return emojis[severity];
}
export function getHealthScoreLabel(score) {
    if (score >= 90)
        return 'Excellent - Your site is well-protected';
    if (score >= 75)
        return 'Good - A few things could be improved';
    if (score >= 50)
        return 'Fair - Several issues need attention';
    if (score >= 25)
        return 'Poor - Multiple security gaps found';
    return 'Critical - Immediate action needed';
}
export function getHealthScoreColor(score) {
    if (score >= 80)
        return '#16a34a'; // green-600
    if (score >= 50)
        return '#ca8a04'; // yellow-600
    return '#dc2626'; // red-600
}
//# sourceMappingURL=severity.js.map